module.exports = __webpack_public_path__ + "img/trafficgeneration.a2326d45.webp";